import React, { useEffect, useState } from "react";
import "./MainSideNavPanel.scss";
import { CheckCircleFilled, MessageOutlined, UserOutlined } from "@ant-design/icons";

type MainSideNavPanelProps = {
  onTabClick?: (tab: string) => void;
  journey: string;
};

const MainSideNavPanel: React.FC<MainSideNavPanelProps> = ({
  onTabClick,
  journey,
}) => {
  const [selectedTab, setSelectedTab] = useState("all-patients");

  const menus = [
    {
      id: "all-patients",
      title: "New Patients",
      icon: <UserOutlined />
    },
    {
      id: "verified-patients",
      title: "Verified Patients",
      icon: <div className="verified-patients-icon">
        <UserOutlined />
        <CheckCircleFilled className="verified-icon" />
        </div>
    },
    {
      id: "chat-app",
      title: "Chat App",
      icon: <MessageOutlined />
    },
    {
      id: "chat-app-v2",
      title: "Chat App v2",
      icon: <MessageOutlined />
    },
  ];

  useEffect(() => {
    setSelectedTab(journey || selectedTab);
  });

  const handleTabClick = (tab: string) => {
    setSelectedTab(tab);
    onTabClick?.(tab || journey);
  };

  return (
    <div className="main-side-nav-panel">
      {menus?.map((menu, index) => (
        <div
          className={`menu-item ${selectedTab === menu.id ? "active-menu-item" : ""}`}
          onClick={() => handleTabClick(menu.id)}
          key={`menu-${index}`}
        >
          <div className={"menu-icon"}>{menu.icon}</div>
          <div className="menu-title">{menu?.title}</div>
          {selectedTab === menu.id && <div className="active-bar" />}
        </div>
      ))}
    </div>
  );
};

export default MainSideNavPanel;
